import { createFeatureActionNamer } from '../../../../redux/action-name';

const getActionName = createFeatureActionNamer('dispute');
export const ADD_DISPUTE_RECORD = getActionName('ADD_DISPUTE_RECORD');
export const EDIT_DISPUTE_RECORD = getActionName('EDIT_DISPUTE_RECORD');
export const SUBMIT = getActionName('SUBMIT');
